import React from 'react'
import { css } from '@emotion/core'

type RefineButtonProps = {
  onSearch?: () => void
}

export const RefineButton: React.FC<RefineButtonProps> = ({ onSearch }) => {
  return (
    <div css={wrapperStyle} className={'field'}>
      <button css={buttonStyle} onClick={onSearch}>
        絞り込み
      </button>
    </div>
  )
}

const wrapperStyle = css({
  position: 'relative',
  width: '75px',
})

const buttonStyle = css({
  position: 'absolute',
  bottom: 0,
  appearance: 'none',
  whiteSpace: 'nowrap',
  border: 'none',
  padding: '7px 14px',
  color: '#FFFFFF',
  backgroundColor: '#004CAD',
  borderRadius: '22px',
  fontSize: '12px',
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.8,
  },
})
